import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { grey } from '@mui/material/colors';
import { Container } from '@mui/material';
import { notification } from '../../utils/Notifications.js';
import { getCategories } from '../../api/categoriesApi.js'
import { getClientInfo, getUserBalances, getUserCredits } from "../../api/userApi.js";
import useLogout from "../../hooks/auth/authHook.js";
import Title from '../../components/SharedComponents/Title/index.js';
import ClientsDetailsHeader from '../../components/Clients/ClientsDetailsHeader/index.js';
import { usePermissions } from '../../hooks/permissions/usePermissions.js';

const ClientsDetails = () => {
  const [logout] = useLogout();

  const { id } = useParams();

  const [user, setUser] = useState();
  const [categories, setCategories] = useState();
  const [credits, setCredits] = useState();
  const [balance, setBalance] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { hasAllPermissions } = usePermissions();

  const fetchClientCredits = () => {
    setIsLoading(true);
    getUserCredits(id)
      .then((response) => {
        if (response.data.status_Code === 200) {
          setCredits(response.data);
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al obtener datos del cliente",
            type: "error",
          });
        }
      })
      .catch((error) => {
        notification({
          text: "Error de conexión, revisa tu conexión a internet",
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  const fetchClientBalance = () => {
    setIsLoading(true);
    getUserBalances(id)
      .then((response) => {
        if (response.data.status_Code === 200) {
          setBalance(response.data);
        } else if (response.data.status_Code === 401) {
          setIsLoading(false);
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          setIsLoading(false);
          notification({
            text: "Error al obtener datos del cliente",
            type: "error",
          });
        }
      })
      .catch((error) => {
        notification({
          text: "Error de conexión, revisa tu conexión a internet",
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  const fetchClientInfo = () => {
    setIsLoading(true);
    getClientInfo(id)
      .then((response) => {
        if (response.data.status_Code === 200) {
          setUser(response.data.info_user);
        } else if (response.data.status_Code === 401) {
          setIsLoading(false);
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          setIsLoading(false);
          notification({
            text: "Error al obtener datos del cliente",
            type: "error",
          });
        }
      })
      .catch((error) => {
        notification({
          text: "Error de conexión, revisa tu conexión a internet",
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  const fetchCategories = () => {
    setIsLoading(true);
    getCategories({validatePermissions: 'false', filterActive: 'true'})
      .then((response) => {
        if (response.data.status_Code === 200) {
          setCategories(response.data.ls_membership_types);
        } else if (response.data.status_Code === 401) {
          setIsLoading(false);
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          setIsLoading(false);
          notification({
            text: "Error al obtener datos del cliente",
            type: "error",
          });
        }
      })
      .catch((error) => {
        notification({
          text: "Error de conexión, revisa tu conexión a internet",
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {

    fetchCategories();

    if (hasAllPermissions(["cli_vwi", "cli_vw"])) {
      fetchClientInfo();
    }

    if (hasAllPermissions(["cli_vwc", "cli_vw"])) {
      fetchClientCredits();
    }

    if (hasAllPermissions(["cli_vwb", "cli_vw"])) {
      fetchClientBalance();
    }
  }, [id]);

  return (
    <Container style={{ minHeight: '100%', backgroundColor: grey[100], padding: '24px', }}>
      <Title title='Detalles de cliente' />
      <ClientsDetailsHeader idUser={id} fetchClientInfo={fetchClientInfo} fetchCategories={fetchCategories} fetchClientCredits={fetchClientCredits} fetchClientBalance={fetchClientBalance} isLoading={isLoading} user={user} categories={categories} credits={credits} balance={balance} /> 
    </Container>
  );
}

export default ClientsDetails